<template>
  <CommonList
    selection-type="radio"
    row-key="id"
    :has-more-search="false"
    :auto-load="true"
    ref="listRef"
    cell-overflow="ellipsis"
    @selection-change="handleSelectionChange"
    @current-row-change="handleCurrentRowChange"
    @load-start="handleLoadList"
    @search-click="handleLoadList"
    @pagination-change="handleLoadList"
    @reset-click="handleReset"
  >
    <template #search-item-fixed>
      <div class="common-search-item">
        <label class="common-search-label80">查询月份:</label>
        <el-date-picker
          v-model="searchForm.queryMonth"
          type="month"
          placeholder="选择月份"
          value-format="YYYY-MM"
          class="common-input150"
          clearable
        />
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">查询日期:</label>
        <el-date-picker
          v-model="searchForm.queryDate"
          type="date"
          placeholder="选择日期"
          value-format="YYYY-MM-DD"
          class="common-input150"
          clearable
        />
      </div>
    </template>

    <template #btn-group>
      <el-button type="success" class="list-btn" @click="handleImportYearHolidays" :loading="importLoading">
        <el-icon><Download/></el-icon>
        一键导入本年节假日
      </el-button>
      <el-button type="primary" class="list-btn" @click="handleAdd">
        <el-icon><Plus/></el-icon>
        新增
      </el-button>
      <el-button
        type="warning"
        class="list-btn"
        @click="handleEdit"
        :disabled="!listShow"
      >
        <el-icon><Edit/></el-icon>
        修改
      </el-button>
      <el-button
        type="danger"
        class="list-btn"
        @click="handleDelete"
        :disabled="!listShow"
      >
        <el-icon><Delete/></el-icon>
        删除
      </el-button>
    </template>

    <template #table-column>
      <el-table-column prop="holidayDate" label="日期" align="center" width="150">
        <template #default="scope">
          {{ $formatTime(scope.row.holidayDate, 'YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column prop="isHoliday" label="是否假期" align="center" width="120">
        <template #default="scope">
          <el-tag :type="scope.row.isHoliday === '1' ? 'danger' : 'success'">
            {{ scope.row.isHoliday === '1' ? '假期' : '工作日' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="holidayName" label="假期名称" align="center" min-width="150">
        <template #default="scope">
          {{ scope.row.holidayName || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="180">
        <template #default="scope">
          {{ $formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
    </template>

    <template #extra>
      <el-dialog
        v-model="dialogVisible"
        :title="dialogType === 'add' ? '新增假期' : '修改假期'"
        width="500px"
        destroy-on-close
      >
        <el-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="100px"
          class="list-modal-form"
        >
          <el-form-item label="日期" prop="holidayDate">
            <el-date-picker
              v-model="formData.holidayDate"
              type="date"
              placeholder="选择日期"
              value-format="YYYY-MM-DD"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item label="是否假期" prop="isHoliday">
            <el-radio-group v-model="formData.isHoliday">
              <el-radio value="1">假期</el-radio>
              <el-radio value="0">工作日</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="假期名称" prop="holidayName">
            <el-input
              v-model="formData.holidayName"
              placeholder="请输入假期名称"
              maxlength="50"
              style="width: 100%;"
            ></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <div style="text-align: center; width: 100%;">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </template>
  </CommonList>
</template>

<script setup>
import useHolidayList from './holidayList.js';

const {
  searchForm,
  listRef,
  dialogVisible,
  dialogType,
  formRef,
  listShow,
  formData,
  formRules,
  importLoading,
  Plus,
  Edit,
  Delete,
  Download,
  handleSelectionChange,
  handleCurrentRowChange,
  handleAdd,
  handleEdit,
  handleDelete,
  handleLoadList,
  handleReset,
  handleSubmit,
  handleImportYearHolidays
} = useHolidayList();
</script>

<style>
@import '../../../assets/css/util/base-list.css';
</style>
